import { render, staticRenderFns } from "./UnemployedRegisterEvaluator.vue?vue&type=template&id=52af3e72&scoped=true&"
import script from "./UnemployedRegisterEvaluator.vue?vue&type=script&lang=js&"
export * from "./UnemployedRegisterEvaluator.vue?vue&type=script&lang=js&"
import style0 from "./UnemployedRegisterEvaluator.vue?vue&type=style&index=0&id=52af3e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af3e72",
  null
  
)

export default component.exports